import {createWebSocketService} from '../dam/damWebSocketService';
import uamfAsyncRequestService from './uamfAsyncRequestService';
import UamfWebSocketClient from './uamfWebSocketClient';
import uamfWebSocketResponseService from './uamfWebSocketResponseService';

const uamfWebSocketService = createWebSocketService({
    servicePrefix: 'uamfWebSocketService',
    WebSocketClientClass: UamfWebSocketClient,
    responseService: uamfWebSocketResponseService,
    asyncRequestService: uamfAsyncRequestService,
});

export default uamfWebSocketService;
